<template lang="pug">
#tabela-cadastrar-contrato-originacao
    el-table(
        :data='contratosNaoEnviados',
        v-loading='carregando',
        @sort-change='ordenarContratos',
        @selection-change='alterarContratosSelecionados'
    )
        el-table-column(type='selection', width='50', v-if='removendo')
        el-table-column(
            prop='numeroContrato',
            label='Número do contrato',
            sortable='custom',
            width='190'
        )
        el-table-column(prop='material', label='Cultura', sortable='custom')
        el-table-column(prop='safraNome', label='Safra', width='100')
        el-table-column(
            prop='volumeContratado',
            label='Volume contratado (t)',
            sortable='custom',
            width='190'
        )
        el-table-column(
            prop='dataContrato',
            label='Data do contrato',
            sortable='custom',
            width='170'
        )
        el-table-column(prop='subEmpresaNome', label='Fornecedor')
        el-table-column(prop='cnpjSubEmpresa', label='CNPJ')
        el-table-column(type='expand')
            template(slot-scope='scope')
                el-descriptions
                    el-descriptions-item(label='Regional')
                        p {{ scope.row.regional }}

                el-descriptions
                    el-descriptions-item(label='Gerente regional')
                        p {{ scope.row.gerenteRegionalNome }}

                el-descriptions
                    el-descriptions-item(label='Gerente comercial')
                        p {{ scope.row.gerenteComercialNome }}

                el-descriptions
                    el-descriptions-item(label='Gestor territorial')
                        p {{ scope.row.gestorTerritorialNome }}
        template(slot='empty')
            el-empty(description='Sem dados')
</template>

<script>
export default {
    name: 'TabelaCadastarContratoOriginacao',

    props: {
        contratosNaoEnviados: {
            type: Array,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        removendo: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            contratosSelecionados: [],
            colunaOrdenacao: {
                numeroContrato: () => 'numero_contrato_valor',
                volumeContratado: () => 'volume_contratado',
                dataContrato: () => 'data_contrato',
                material: () => 'material'
            }
        };
    },

    methods: {
        alterarContratosSelecionados(linhas) {
            this.contratosSelecionados = linhas;
            this.$emit(
                'contratosSelecionados',
                this.contratosSelecionados.map(
                    ({ numeroContrato }) => numeroContrato
                )
            );
        },

        ordenarContratos({ order, prop }) {
            const ordem = order === 'ascending' ? 'asc' : 'desc';
            const coluna = this.colunaOrdenacao[prop]();
            this.$emit('ordenar', `${coluna},${ordem}`);
        }
    }
};
</script>

<style lang="scss">
#tabela-cadastrar-contrato-originacao {
    td.el-table__cell.el-table__expanded-cell {
        margin: 0 16px;
        display: flex;
        justify-content: space-between;
        width: 700px;

        .el-descriptions-item__container {
            display: flex;
            flex-direction: column;

            span.el-descriptions-item__label {
                font-weight: bold;
                color: var(--primary);
            }
        }
    }
    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }

    .el-table .cell {
        word-break: normal;
    }
}
</style>
